import { CustomerType } from 'client/actions/customer'
import { CompanyInterface } from 'client/Interfaces/CompanyInterface'
import { ConfigInterface } from 'client/Interfaces/ConfigsInterface'
import { CustomerInterface } from 'client/Interfaces/CustomerInterface'
import { areWithinFrenchTerritories, countriesWithinEU } from 'client/Other/Countries'
import omitBy from 'lodash/omitBy'

const SALES_WITHIN_EU = ['SALES_EU_GOODS', 'SALES_EU_SERVICES']
const SALES_NONEU = ['SALES_NONEU_GOODS', 'SALES_NONEU_SERVICES']

export const getInvoiceTypesMap = (
  company: CompanyInterface,
  config: ConfigInterface,
  customer?: CustomerInterface,
  invoiceTypes?: { [key: string]: string },
) => {
  const map = { ...invoiceTypes }

  const customerCountry = customer?.address?.country
  const customerType = customer?.customerType
  const companyCountry = company?.country

  if (!customerCountry || customerType === CustomerType.PRIVATE) {
    return map
  }

  const typesToOmit: string[] = []

  if (customerCountry !== companyCountry && !areWithinFrenchTerritories(companyCountry, customerCountry)) {
    typesToOmit.push('SALES')

    if (countriesWithinEU.includes(customerCountry)) {
      typesToOmit.push(...SALES_NONEU)
    } else {
      typesToOmit.push(...SALES_WITHIN_EU)
    }
  } else {
    typesToOmit.push(...SALES_NONEU, ...SALES_WITHIN_EU)
  }

  return omitBy(map, (_value, key) => {
    return typesToOmit.includes(config.invoiceTypes[key].type as string)
  })
}
